module.exports = __webpack_public_path__ + "img/Butterfly_00242.faea0cfc.png";